import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IAskForQuotationProduct } from 'src/app/features/quotes/models/quotes.models';

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const valid = emailRegex.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
}

export function quantityValidator(
  product: IAskForQuotationProduct,
  translateService: TranslateService
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (isNaN(value) || value <= 0) {
      return { quantityInvalid: translateService.instant('catalogs_listing.quantity_must') };
    }

    if (product.min_qte !== undefined && product.min_qte !== null && value < product.min_qte) {
      return {
        quantityMin: translateService.instant('catalogs_listing.min_quanty') + product.min_qte,
      };
    }

    if (product.max_qte !== undefined && product.max_qte !== null && value > product.max_qte) {
      return {
        quantityMax: translateService.instant('catalogs_listing.max_quanty') + product.max_qte,
      };
    }

    if (
      product.increment !== undefined &&
      product.increment !== null &&
      value % product.increment !== 0
    ) {
      return {
        quantityIncrement:
          translateService?.instant('catalogs_listing.quantity_muste') + product.increment,
      };
    }

    return null; // No errors found
  };
}

// Password must be at least 8 characters, contain at least one letter and one number, and not start or end with whitespace
export function passwordValidator(): ValidatorFn {
  const pattern = /^(?!.*\s$)(?!^\s)(?=.*[A-Za-z])(?=.*\d).{8,}$/;
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return pattern.test(value) ? null : { invalidPassword: true };
  };
}

export function matchValidator(firstCtrlKey: string, secondCtrlKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const firstCtrl = group.get(firstCtrlKey)?.value;
    const secondCtrl = group.get(secondCtrlKey)?.value;
    if (firstCtrl && secondCtrl && firstCtrl !== secondCtrl) {
      return { mismatch: true };
    }
    return null;
  };
}
